import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
import { Router, ActivatedRoute, NavigationEnd, ParamMap } from '@angular/router';
import { SocoHttpService } from '@soco/http';
import { DBTraceLogService } from '../../shared/services/dbTraceLog/dbTraceLog.service';
import { CoolEmailService } from '../../shared/services/coolEmail/coolEmail.service';
import { AppCommonService } from '../../shared/services/common/app-common.service';
import { DatePipe } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DBTraceLog, LogType } from '../../shared/services/dbTraceLog/dbTraceLog-entities';
import { AppConfigurationData } from '../../shared/services/common/app-common-entities';
import { AppBaseComponent } from '../../shared/components/base/app-base.component';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    providers: [HttpService, DatePipe, DBTraceLogService, CoolEmailService, AppCommonService]
})
export class FaqComponent extends AppBaseComponent implements OnInit {
  public param: any = '';
  public rescheduleObj: any;
  public response: any;
  public faq: boolean;
  public ObjectQ1: Array<any> = [];
  public ObjectQ2: Array<any> = [];
  public ObjectQ3: Array<any> = [];
  public ObjectQ4: Array<any> = [];
  public ldc: string = '';

    public orderType: string = '';
    public orderNumber: string = '';
    public deviceInfo = null;
    public dbTraceLog: DBTraceLog;
    public logReferenceID: string = '';
    public appConfigurationDataList: Array<AppConfigurationData> = [];
    public emailToList: string;

    constructor(public httpService: HttpService, private route: ActivatedRoute, private router: Router, public datepipe: DatePipe,
        public socoHttp: SocoHttpService, public dbTraceLogService: DBTraceLogService, public deviceService: DeviceDetectorService,
        public coolEmailService: CoolEmailService, private appCommonService: AppCommonService) {

        //Parent component instantiation
        super(socoHttp, dbTraceLogService, coolEmailService, deviceService);

        this.param = this.route.snapshot.url[1].path;

        this.logReferenceID = this.datepipe.transform(Date.now(), "MMddyyyyHHmmss");
        this.insertDBTraceLog(LogType.Info, 'FAQ component initiated successfully');

        //this.httpService.getData(this.param).subscribe(ApiResult => {
        //    console.log('Reschedule-->', ApiResult);
        //    this.response = ApiResult;
        //    if(this.response.data){
        //    let a = this.response.data.faqs;
        //    this.ldc = this.response.data.ldc;
        //    this.parseData(a);
        //    this.faq = true;
        //    }
        //});
    
    };

    ngOnInit() {
        try
        {
            this.GetFAQDataWithAppConfigs();
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading FAQ info, Error: ' + e.message.substring(0, 500));
        }
    }


    GetFAQDataWithAppConfigs() {
        try {
            
            this.appCommonService.getApplicationConfigs().subscribe(ApiResult => {

                if (ApiResult.data != null) {

                    this.insertDBTraceLog(LogType.Info, 'Application configs fetched successfully');

                    ApiResult.data.forEach(configData => {
                        this.appConfigurationDataList.push(configData);
                    });

                    this.emailToList = this.appConfigurationDataList.filter(item => (item.configurationKey == 'EmailTo'))
                        .map(cv => cv.configurationValue)[0];

                    //Fetch FAQ Data
                    this.GetFAQData();

                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching application configs, API Result is Null');
                }

            }, ApiResult => {
                //capture error
                if (this.socoHttp.isInvalidResult(ApiResult) || this.socoHttp.isErrorResult(ApiResult) || this.socoHttp.isFailureResult(ApiResult)) {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching application configs');
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while fetching application configs, Error: ' + e.message.substring(0, 500));
        }
    }

    GetFAQData() {
        try {

            this.httpService.getData(this.param).subscribe(ApiResult => {

                this.response = ApiResult;

                if (ApiResult != null && ApiResult.statusCode == 200) {
                    if (this.response.data) {
                        let a = this.response.data.faqs;
                        this.ldc = this.response.data.ldc;
                        this.parseData(a);
                        this.faq = true;

                        this.insertDBTraceLog(LogType.Info, 'FAQ info loaded successfully');
                    }
                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while loading FAQ info, APIResult is null or APIResult is not 200');
                }
            }, ApiResult => {
                if (this.socoHttp.isInvalidResult(ApiResult) || this.socoHttp.isErrorResult(ApiResult) || this.socoHttp.isFailureResult(ApiResult)) {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while loading FAQ info, APIResult is invalid');
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading FAQ info, Error: ' + e.message.substring(0, 500));
        }
    }



  parseData(a) {
    for (let i = 0; i < a.length; i++) {
        if (a[i].heading.indexOf("Q1") !== -1) {
            this.ObjectQ1.push(a[i]);
        }else if(a[i].heading.indexOf("Q2") !== -1){
            this.ObjectQ2.push(a[i]);
        }else if(a[i].heading.indexOf("Q3") !== -1){
            this.ObjectQ3.push(a[i]);
        }else {
            this.ObjectQ4.push(a[i]);
        }
    }
    //console.log(JSON.stringify(this.ObjectQ1));
    //console.log(JSON.stringify(this.ObjectQ2));
    //console.log(JSON.stringify(this.ObjectQ3));
    //console.log(JSON.stringify(this.ObjectQ4));
    }


    private insertDBTraceLog(logType: string, logMessage: string) {

        this.dbTraceLog = new DBTraceLog();

        this.dbTraceLog.portalTypeID = 1; //Customer Portal
        this.dbTraceLog.ldc = this.ldc;
        this.dbTraceLog.kmiUrlCode = this.param;
        this.dbTraceLog.issuingApOrderID = this.orderNumber;
        this.dbTraceLog.orderType = this.orderType;
        this.dbTraceLog.logReferenceID = this.logReferenceID;
        this.dbTraceLog.logType = logType;
        this.dbTraceLog.logMessage = logMessage;        
        this.dbTraceLog.emailToList = this.emailToList;

        super.InsertDBTraceLogThruBase(this.dbTraceLog);
    }
}
